import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";
import { Link } from "react-router-dom";
import { trackEvent } from "../analytics";

export default function Navbar() {
  return (
    <header className="bg-purple-900 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <Link
          to="/"
          className="flex title-font font-medium items-center text-white mb-4 md:mb-0"
        >
          <img
            src="/logo-mantle.svg"
            alt="Mantle Tech Solutions"
            className="w-8 h-8"
          />
          <span className="ml-3 text-xl md:text-2xl">
            Mantle Tech Solutions
          </span>
        </Link>
        <div className="flex flex-wrap items-center justify-center md:ml-auto gap-x-8 gap-y-4">
          <nav className="flex flex-wrap items-center justify-center text-base gap-x-6">
            <Link to="/#services" className="text-purple-200 hover:text-white">
              Services
            </Link>
            <Link to="/#solution-packs" className="text-purple-200 hover:text-white">
              Solution Packs
            </Link>
            <Link to="/#who-we-help" className="text-purple-200 hover:text-white">
              Who We Help
            </Link>
            <Link to="/#projects" className="text-purple-200 hover:text-white">
              Our Work
            </Link>
            <Link to="/blog" className="text-purple-200 hover:text-white">
              Insights
            </Link>
            <Link to="/#faq" className="text-purple-200 hover:text-white">
              FAQ
            </Link>
          </nav>
          <Link
            to="/#contact"
            onClick={() => trackEvent("cta_click", { location: "navbar" })}
            className="inline-flex items-center bg-purple-500 text-white border-0 py-2 px-5 focus:outline-none hover:bg-purple-400 rounded-full text-base font-medium"
          >
            Work With Us
            <ArrowRightIcon className="w-4 h-4 ml-1" />
          </Link>
        </div>
      </div>
    </header>
  );
}
